// Self-pay Financial Policy Service

const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:3001';
  return '';
};

export const saveSelfPayPolicy = async (policyPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/selfpay-policy`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(policyPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to save self-pay policy');
    return { success: true, ...data };
  } catch (err) {
    console.error('SelfPayPolicyService.saveSelfPayPolicy error:', err);
    return { success: false, error: err.message };
  }
};

export const sendSelfPayPolicyEmail = async (policyPayload) => {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/selfpay-policy/send-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(policyPayload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Failed to send policy email');
    return { success: true, ...data };
  } catch (err) {
    console.error('SelfPayPolicyService.sendSelfPayPolicyEmail error:', err);
    return { success: false, error: err.message };
  }
};
